import { render } from "./ToastAlert.vue?vue&type=template&id=bc110c1c"
import script from "./ToastAlert.vue?vue&type=script&lang=js"
export * from "./ToastAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__